<template>
    <div>
        <div @click="dialogVisible=true"><slot></slot></div>
        <el-dialog v-if="userinfo"
                title="账号认证" class="fotoo"
                :visible.sync="dialogVisible"
                   @open="queryUserInfo"
                width="50%" append-to-body
                :before-close="handleClose">
            <div class="solid-top flex flex-direction align-center padding-xl">
                <el-descriptions title="" :column="2" size="mini" border class="margin-bottom">
                    <el-descriptions-item label="ID">{{userinfo.id}}</el-descriptions-item>
                    <el-descriptions-item label="用户名">{{userinfo.userName}}</el-descriptions-item>
                </el-descriptions>
                <el-form ref="form" :model="form" :rules="rules"
                         label-width="120px">
                    <el-form-item label="认证状态" prop="isAttestation">
                        <el-switch v-model="form.isAttestation"></el-switch>
                    </el-form-item>
                    <el-form-item label="认证类型" prop="orgType">
                        <el-select v-model="form.orgType" placeholder="请选择">
                            <el-option label="个人" :value="1"></el-option>
                            <el-option label="企业" :value="2"></el-option>
                            <el-option label="机构" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="认证名称" prop="orgName">
                        <el-input v-model="form.orgName" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="认证周期" prop="daterange">
                        <el-date-picker
                                v-model="form.daterange" :editable="false"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提 交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
  import App from '../../../util/comfun'
  import QRCode from 'qrcodejs2'
  export default {
    props:{
        userId:String,
    },
    data () {
      return {
        MG:App.MG,
        unixtoTime:App.unixtoTime,
        userinfo:{},
        form:{
          daterange:[],
        },
        dialogVisible:false,
        rules: {
          orgName: [
            {required: true, message: '请输入', trigger: 'blur'},
          ],
          orgType: [
            {required: true, message: '请选择类型', trigger: 'blur'},
          ],
          daterange: [
            {required: true, message: '请输入', trigger: 'blur'},
          ],
        },
        pickerOptions: {
          shortcuts: [{
            text: '往后一年',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(start.getTime() + 86400000 * 366);
              picker.$emit('pick', [start, end]);
            }
          },]
        },
      }
    },
    methods:{
      handleClick(){},
      handleClose(done) {
        this.$refs.form.resetFields()
        done();
      },
      gotoHome(){
        this.$router.back()
      },
      queryUserInfo(){
        this.queryUserBase()
        let userRes=App.demand('/user/info','GET',{
          userId:this.userId,
        }).then(res=>{
          this.userinfo=res.data
        })
      },
      queryUserBase(){
        let userRes=App.demand('/user/attestationInfo','GET',{
          userId:this.userId,
        }).then(res=>{
          this.form=res.data
          this.form.isAttestation=this.form.isAttestation==1
          this.form.datetime=[]
          if(this.form.attestationStartTime && this.form.attestationEndTime){
            this.form.daterange=[
              new Date(this.form.attestationStartTime*1000),
              new Date(this.form.attestationEndTime*1000),
            ]
          }
        })
      },
      onSubmit(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading=this.$loading({text:'处理中...',target:'.el-drawer'})
            App.demand('/admin/user/saveAttestationInfo','POST',{
              "attestationStartTime": App.unixtoTime(this.form.daterange[0]/1000,'YYYY-MM-DD HH:II:SS'),
              "attestationEndTime": App.unixtoTime(this.form.daterange[1]/1000,'YYYY-MM-DD HH:II:SS'),
              "isAttestation": this.form.isAttestation?1:0,
              "orgType": this.form.orgType,
              "orgName": this.form.orgName,
              "userId": this.userinfo.id,
            }).then(res=>{
              this.loading.close()
              if(res.code!=200) {return this.$message(res.message)}
              this.$emit('event');
              this.$refs.form.resetFields()
              this.dialogVisible=false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    },
    mounted(){
        //this.queryUserInfo()
    },

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/components/certification/update.vue